import { render, staticRenderFns } from "./BanksForm.vue?vue&type=template&id=024c21c9&scoped=true&"
import script from "./BanksForm.vue?vue&type=script&lang=js&"
export * from "./BanksForm.vue?vue&type=script&lang=js&"
import style0 from "./BanksForm.vue?vue&type=style&index=0&id=024c21c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024c21c9",
  null
  
)

export default component.exports